import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SystemCodes from "./SystemCodes";
import { ErrorMessage } from "../ErrorMessage";

const SystemCodeCategorySelect = ({
  value,
  label,
  size,
  name,
  onChange,
  icon,
  where,
  required,
  orderByMulti = ["Category_DESC"]
}) => (
  <Field>
    <SystemCodes
      variables={{
        where,
        orderByMulti
      }}
    >
      {({ data, loading, error }) => {
        if (error) return <ErrorMessage error={error} />;
        const codes = data ? data.SystemCodes : null;
        return codes ? (
          <Control iconLeft size={size}>
            <Select.Container
              fullwidth
              color={
                error || (required && (value === "" || value === "0"))
                  ? "danger"
                  : "secondary"
              }
              size={size}
              state={loading ? "loading" : null}
            >
              <Select
                name={name}
                required={required}
                value={value}
                onChange={onChange}
              >
                <Select.Option value={0}>{label}</Select.Option>
                {!loading &&
                  [...new Set(data.SystemCodes.map(c => c.Category))].map(
                    (Category, i) => (
                      <Select.Option
                        key={`system-code-select-${i}`}
                        value={Category}
                      >
                        {Category}
                      </Select.Option>
                    )
                  )}
              </Select>
            </Select.Container>
            {icon && (
              <Icon align="left" size={size}>
                <FontAwesomeIcon icon={icon} />
              </Icon>
            )}
          </Control>
        ) : null;
      }}
    </SystemCodes>
  </Field>
);

SystemCodeCategorySelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.string,
  where: PropTypes.object,
  required: PropTypes.bool,
  orderByMulti: PropTypes.array
};
SystemCodeCategorySelect.defaultProps = {
  value: 0,
  icon: "globe",
  where: {}
};
export default SystemCodeCategorySelect;
